import { connectHits } from 'react-instantsearch-dom'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Hit from './hit'

import trads from '../../intl/trads.json'

import {setCurrentSearchQuery, setCurrentSearchFilters} from '../../store/actions'

const Hits = ({hits}) => {
  const lang = useSelector(state => state.lang)
  const dispatch = useDispatch()

  const setSearchState = () => {
    let searchQuery = document.querySelector('.ais-SearchBox-input').value
    let searchFilters = []
    let searchFiltersItems = document.querySelectorAll('.ais-RefinementList-item--selected')

    searchFiltersItems.forEach(item => {
      searchFilters.push(item.dataset.value)
    })

    dispatch(setCurrentSearchQuery(searchQuery))
    dispatch(setCurrentSearchFilters(searchFilters))
  }


  return (
    <div className="mt-5 md:mt-8 mb-12">
      {hits.length > 0
        ? <ul>
            {hits.map((hit, i) => { 
              return (
                <li className="mb-6" key={hit.objectID}>
                  <Hit hit={hit} setSearchState={setSearchState} />
                </li>
              ) 
            }) }
          </ul>
        : trads[lang].newsroom.noResults
      }
    </div>
  )
}

const CustomHits = connectHits(Hits);

export default CustomHits;